<template>
  <v-container>
    <v-card style="border: black 1px solid">
      <v-list-item three-line>
        <v-list-item-content>
          <v-list-item-title class="headline mb-1"><span>แก้ไขข้อมูลหลักสูตร</span></v-list-item-title>
          <v-list-item>
            <v-row
                justify="center">
              <v-col
                  cols="12"
                  md="4">
                <v-autocomplete
                    :items="Course_Data"
                    item-text="Course_name"
                    item-value="Course_code"
                    v-model="Course_Choose"
                    label="เลือกหลักสูตร"
                    :rules="[rules.required]"
                    required
                    @change="Choose_Course"
                ></v-autocomplete>
              </v-col
              >
            </v-row>
          </v-list-item>
          <v-list-item>
            <v-row>
              <v-col
                  cols="12"
                  md="4"
              >
                <div class="d-inline">
                  <v-text-field
                      disabled
                      label="รหัสหลักสตร" hide-details="auto"
                      v-model="Course_code"
                      counter="8"
                      maxlength="8"
                      hint="ไม่เกิน 8 ตัวอักษร"
                      :rules="[rules.required, rules.counterCourse]"></v-text-field>
                </div>
              </v-col>
              <v-col
                  cols="12"
                  md="5"
              >
                <div class="d-inline">
                  <v-text-field label="ชื่อหลักสูตร" hide-details="auto"
                                v-model="Course_name"
                                :rules="[rules.required]"></v-text-field>
                </div>
              </v-col>
              <v-col
                  cols="12"
                  md="3"
              >
                <div class="d-inline">
                  <v-text-field label="ทำซํ้า (ปี)" hide-details="auto"
                                v-model="Booster"
                                :rules="[rules.required]"></v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-list-item>
          <v-list-item>
            <v-row>
              <v-col
                  cols="12"
                  md="4"
              >
                <div class="d-inline">
                  <v-autocomplete
                      :items="DepartData"
                      item-text="dep_name"
                      item-value="dep_id"
                      v-model="Dep_model"
                      label="หน่วยงาน"
                      :rules="[rules.required]"
                      required
                  >
                    <template v-slot:item="{item}">
                      <span style="color: darkslategrey">{{ item.dep_name }}</span>
                    </template>
                    <template v-slot:selection="{item}">
                      <span style="color: darkorange">{{ item.dep_name }}</span>
                    </template>
                  </v-autocomplete>
                </div>
              </v-col>
              <v-col
                  cols="12"
                  md="4"
              >
                <div class="d-inline">
                  <v-select
                      :items="CourseGroupData"
                      item-text="Course_group_des"
                      item-value="Course_group"
                      v-model="Course_group"
                      label="กลุ่มหลักสูตร"
                      :rules="[rules.required]"
                      required
                  ></v-select>
                </div>
              </v-col>
              <v-col
                  cols="12"
                  md="4"
              >
                <div class="d-inline">
                  <v-select
                      :items="CourseTypeData"
                      item-text="Course_type_des"
                      item-value="Course_type"
                      v-model="Course_type"
                      label="สาขาประเภทหลักสูตร"
                      :rules="[rules.required]"
                      required
                  ></v-select>
                </div>
              </v-col>
            </v-row>
          </v-list-item>
          <v-list-item>
            <v-row>
              <v-col
                  cols="4"
              >
                <div class="d-inline">
                  <v-text-field label="จำนวน ช.ม" hide-details="auto"
                                v-model="Course_hour"
                                :rules="[rules.required]"></v-text-field>
                </div>
              </v-col>
              <v-col
                  cols="4"
              >
                <div class="d-inline">
                  <v-text-field label="จำนวนเครดิต" hide-details="auto"
                                v-model="General_credit"
                                :rules="[rules.required]"></v-text-field>
                </div>
              </v-col>
              <v-col
                  cols="4"
              >
                <div class="d-inline">
                  <v-select
                      :items="period"
                      item-text="name"
                      item-value="id"
                      v-model="Period_code"
                      label="ระยะเวลา"
                      :rules="[rules.required]"
                      required
                  ></v-select>
                </div>
              </v-col>
            </v-row>
          </v-list-item>
          <v-list-item>
            <v-row>
              <v-col
                  cols="12"
              >
                <div class="d-inline">
                  <v-textarea
                      outlined
                      name=""
                      label="รายละเอียดประกอบหลักสูตร"
                      value=""
                      :rules="[rules.required]"
                      v-model="Course_des"
                  ></v-textarea>
                </div>
              </v-col>
            </v-row>
          </v-list-item>
          <v-list-item class="justify-center">
            <v-btn
                dark
                large
                color="#F57F17"
                @click="UpdateData">แก้ไขข้อมูล
            </v-btn>
          </v-list-item>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios'
import ConstData from '../../const/Const'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "UpdateCourse",
  data() {
    return {
      CheckAdmin: false,
      Dep_model: '',
      Course_Choose: '',
      courseData: '',
      Course_code: '',
      Course_name: '',
      Course_des: '',
      Course_status: '1',
      Course_group: '',
      Course_hour: '',
      Booster: '',
      General_credit: '',
      Period_code: '',
      Course_type: '',
      Course: {
        Course_code: '',
        Course_name: '',
        Course_des: '',
        Course_status: '1',
        Course_group: '',
        Course_hour: '',
        Booster: '',
        General_credit: '',
        Period_code: '',
        Course_type: '',
      },
      rules: {
        required: value => !!value || 'Required.',
        counterCourse: value => value.length <= 8 || 'Max 8 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      Menu: [
        {
          'id': 1,
          'value': 'ข้อมูลหลักสูตร',
          page: '/ManaveCourse/DataCourse'
        },
        {
          'id': 2,
          'value': 'เพิ่มข้อมูลหลักสูตร',
          page: '/ManaveCourse/InsertCourse'
        }],
      period: [
        {
          'name': 'ทั่วไป',
          'id': '1'
        },
        {
          'name': 'ระยะสั้น',
          'id': '2'
        },
        {
          'name': 'ระยะยาว',
          'id': '3'
        }
      ],
      status: [
        'ใช้งาน'
        ,
        'ไม่ใช้งาน'
      ],
      CourseGroup: [
        {
          'name': 'ทั่วไป',
          'id': '1'
        },
        {
          'name': 'วิชาชีพ',
          'id': '2'
        },
        {
          'name': 'บริหารจัดการ',
          'id': '3'
        }
      ],
      CourseType: [
        {
          'name': 'ทั่วไป',
          'id': '1'
        },
        {
          'name': 'เฉพาะตำแหน่ง',
          'id': '2'
        }
      ],
    }
  },
  computed: {
    ...mapGetters({
      MeData: 'Staff/getMeData',
      DepartData: 'Depart/getDepart',
      CourseGroupData: 'Course/getCourseGroup',
      CourseTypeData: 'Course/getCourseType',
      Course_Data: 'Course/getCourse',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      PermissionAdmin: 'Permission/getPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initDepartData: 'Depart/initDepartData',
      CourseGroupInit: 'Course/initCourseGroupData',
      CourseTypeInit: 'Course/initCourseTypeData',
      initCourseData: 'Course/initCourseData',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
    }),
    init: function () {
      if (this.CourseGroupData.length == 0) {
        this.CourseGroupInit()
      }
      if (this.CourseTypeData.length == 0) {
        this.CourseTypeInit()
      }
      if (this.DepartData.length == 0) {
        this.initDepartData()
      }
      // if (this.Course_Data.length == 0) {
      this.initCourseData()
      // }
    },
    Choose_Course: function () {
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_course_view/Course_code/' + this.Course_Choose).then(res => {
        if (res.data) {
          this.Course_code = res.data.Course_code
          this.Course_name = res.data.Course_name
          this.Course_des = res.data.Course_des
          this.Course_status = res.data.Course_status
          this.Course_group = res.data.Course_group
          this.Course_hour = res.data.Course_hour
          this.Booster = res.data.Booster
          this.General_credit = res.data.General_credit
          this.Period_code = res.data.Period_code
          this.Course_type = res.data.Course_type
          this.Dep_model = res.data.Dep_Code
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่มีข้อมูลหลักสูตร'
          })
        }
      })
    },
    UpdateData: function () {

     var CheckUpdate = false
      if (this.PermissionAdmin.length > 0) {
        this.PermissionAdmin.map((Per_i, idx) => {
          if (Per_i.permission_id == '2001') {
            CheckUpdate = true
            if (this.Course_Choose == '') {
              this.$swal.fire({
                icon: 'error',
                title: 'กรุณาเลือกหลักสูตร'
              })
            } else {
              if (this.Course_code == '' || this.Course_name == '' || this.Course_des == ''
                  || this.Course_status == '' || this.Course_group == '' || this.Course_hour == ''
                  || this.Booster == '' || this.General_credit == '' || this.Period_code == ''
                  || this.Course_type == '' || this.Dep_model == '') {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด',
                  text: 'โปรดกรอกข้อมูลให้ครบถ้วน',
                })
              } else {
                this.$swal.fire({
                  title: 'ยืนยันการทำรายการ',
                  text: "ต้องการแก้ไขข้อมูลหลักสูตร ใช่หรือไม่ ??",
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'ตกลง',
                  cancelButtonText: 'ยกเลิก'
                }).then((result) => {
                  if (result.value) {
                    this.Course.Course_code = this.Course_code
                    this.Course.Course_name = this.Course_name
                    this.Course.Course_des = this.Course_des
                    this.Course.Course_status = this.Course_status
                    this.Course.Course_group = this.Course_group
                    this.Course.Course_hour = this.Course_hour
                    this.Course.Booster = this.Booster
                    this.Course.General_credit = this.General_credit
                    this.Course.Period_code = this.Period_code
                    this.Course.Course_type = this.Course_type
                    this.Course.Dep_Code = this.Dep_model
                    this.Course.Update_by = this.MeData[0].perid
                    const headerAxios = {
                      headers: {
                        'Content-Type': 'application/json'
                      }
                    }
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_course/Course_code/' + this.Course_Choose, this.Course, headerAxios).then(res => {
                      if (res.data.status) {
                        this.$swal.fire({
                          icon: 'success',
                          title: 'แก้ไขข้อมูลสำเร็จ'
                        })
                        this.Course_Choose = ''
                        this.Course_code = ''
                        this.Course_name = ''
                        this.Course_des = ''
                        this.Course_status = '1'
                        this.Course_group = ''
                        this.Course_hour = ''
                        this.Booster = ''
                        this.General_credit = ''
                        this.Period_code = ''
                        this.Course_type = ''
                        this.Dep_model = ''
                        this.initCourseData().then((res) => {
                          if (res) {
                            this.init()
                          }
                        })
                      } else {
                        this.$swal.fire({
                          icon: 'error',
                          title: 'พบข้อผิดพลาด',
                          text: 'ไม่สามารถแก้ไขข้อมูลได้',
                        })
                      }
                    });
                  }
                })
              }
            }
          } else {
            if (!CheckUpdate && idx == this.PermissionAdmin.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      } else {
        this.Permission.map((Per_i, idx) => {
          if (Per_i.permission_id == '2001') {
            CheckUpdate = true
            if (this.Course_Choose == '') {
              this.$swal.fire({
                icon: 'error',
                title: 'กรุณาเลือกหลักสูตร'
              })
            } else {
              if (this.Course_code == '' || this.Course_name == '' || this.Course_des == ''
                  || this.Course_status == '' || this.Course_group == '' || this.Course_hour == ''
                  || this.Booster == '' || this.General_credit == '' || this.Period_code == ''
                  || this.Course_type == '' || this.Dep_model == '') {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด',
                  text: 'โปรดกรอกข้อมูลให้ครบถ้วน',
                })
              } else {
                this.$swal.fire({
                  title: 'ยืนยันการทำรายการ',
                  text: "ต้องการแก้ไขข้อมูลหลักสูตร ใช่หรือไม่ ??",
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'ตกลง',
                  cancelButtonText: 'ยกเลิก'
                }).then((result) => {
                  if (result.value) {
                    this.Course.Course_code = this.Course_code
                    this.Course.Course_name = this.Course_name
                    this.Course.Course_des = this.Course_des
                    this.Course.Course_status = this.Course_status
                    this.Course.Course_group = this.Course_group
                    this.Course.Course_hour = this.Course_hour
                    this.Course.Booster = this.Booster
                    this.Course.General_credit = this.General_credit
                    this.Course.Period_code = this.Period_code
                    this.Course.Course_type = this.Course_type
                    this.Course.Dep_Code = this.Dep_model
                    this.Course.Update_by = this.MeData[0].perid
                    const headerAxios = {
                      headers: {
                        'Content-Type': 'application/json'
                      }
                    }
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_course/Course_code/' + this.Course_Choose, this.Course, headerAxios).then(res => {
                      if (res.data.status) {
                        this.$swal.fire({
                          icon: 'success',
                          title: 'แก้ไขข้อมูลสำเร็จ'
                        })
                        this.Course_Choose = ''
                        this.Course_code = ''
                        this.Course_name = ''
                        this.Course_des = ''
                        this.Course_status = '1'
                        this.Course_group = ''
                        this.Course_hour = ''
                        this.Booster = ''
                        this.General_credit = ''
                        this.Period_code = ''
                        this.Course_type = ''
                        this.Dep_model = ''
                        this.initCourseData().then((res) => {
                          if (res) {
                            this.init()
                          }
                        })
                      } else {
                        this.$swal.fire({
                          icon: 'error',
                          title: 'พบข้อผิดพลาด',
                          text: 'ไม่สามารถแก้ไขข้อมูลได้',
                        })
                      }
                    });
                  }
                })
              }
            }
          } else {
            if (!CheckUpdate && idx == this.Permission.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      }


    }
  },
  mounted() {
    this.initMeData().then(res => {
      if (res) {
        this.getPermissionData({
          perid: this.MeData[0].perid
        }).then(res => {
          if (res) {
            this.PermissionAdmin.map((Per_i, idx) => {
              if (Per_i.permission_id == '2000') {
                this.CheckAdmin = true
                this.init()
              } else {
                if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                  this.$router.push('/')
                }
              }
            })
          } else {
            // this.$router.push('/')
            this.getPermissionUserData({
              perid: this.MeData[0].perid
            }).then(res => {
              if (res) {
                this.Permission.map((Per_i, idx) => {
                  if (Per_i.permission_id == '2000') {
                    this.CheckAdmin = true
                    this.init()
                  } else {
                    if (!this.CheckAdmin && idx == this.Permission.length - 1) {
                      this.$router.push('/')
                    }
                  }
                })
              } else {
                this.$router.push('/')
              }
            })
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>